<template>
  <div class="app-container">
    <el-form :inline="true" @keyup.enter.native="toFilter">
      <el-form-item label="资产码">
        <el-input placeholder="请输入资产码" v-model="filter.assetsCode" clearable></el-input>
      </el-form-item>
      <el-form-item label="出场编码">
        <el-input placeholder="请输入出场编码" v-model="filter.FactoryCode" clearable></el-input>
      </el-form-item>
      <el-form-item label="所属站点">
        <el-input placeholder="请输入所属站点名称" v-model="filter.siteName" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" type="primary" @click="toFilter">{{ $t("publics.querybtn") }}</el-button>
      </el-form-item>
    </el-form>

    <el-table header-cell-class-name="table-header-cell" :data="tableData" height="100%" highlight-current-row v-loading="loading">
      <el-table-column label="序号" type="index" width="60"></el-table-column>
      <el-table-column label="资产码" prop="assetsCode" width="220" show-overflow-tooltip></el-table-column>
      <el-table-column label="出场编码" prop="FactoryCode" show-overflow-tooltip></el-table-column>
      <el-table-column label="所属站点" prop="SiteName" show-overflow-tooltip></el-table-column>
      <el-table-column label="设备密钥" prop="SecrtKey" show-overflow-tooltip></el-table-column>
      <el-table-column label="产品密钥" prop="PublickKey" show-overflow-tooltip></el-table-column>
      <el-table-column label="注册码" prop="RegCode" show-overflow-tooltip></el-table-column>
      <el-table-column label="枪个数" prop="Count" width="80"></el-table-column>
      <el-table-column label="设备类型" prop="TypeName" width="120"></el-table-column>
      <el-table-column label="协议类型" prop="dev_type" width="120" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <span  v-if="row.dev_type == 0">恒电聚能协议</span>
          <span  v-else-if="row.dev_type == 1">云快充协议</span>
          <span  v-else>其他协议</span>
        </template>
      </el-table-column>
      <el-table-column label="已使用" prop="IsAdd" width="80">
        <template slot-scope="{ row }">
          <el-tag v-if="row.IsAdd" type="primary">是</el-tag>
          <el-tag v-else type="info">否</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="State" width="80">
        <template slot-scope="{ row }">
          <el-tag type="success" v-if="row.State == 1">启用</el-tag>
          <el-tag type="danger" v-else>禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="CreateTime"></el-table-column>
      <el-table-column :label="$t('publics.operation')" width="140px">
        <template slot-scope="{ row }">
          <el-button type="text" @click="onUpdateProtocolType(row)" v-permision_tjtf="'updateProtocolType'">修改协议类型</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination
        background
        layout="sizes,total,prev,pager,next,jumper"
        :total="pageParams.total"
        :page-size="pageParams.limit"
        :page-sizes="[5, 10, 50, 100, 500, 1000]"
        :current-page="pageParams.page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>

    <!-- 修改协议类型弹窗 -->
    <el-dialog title="修改协议类型" :visible.sync="protocolDialogVisible" width="500px" :close-on-click-modal="false">
      <el-form label-width="110px" :model="protocolForm" ref="protocolFormRef">
        <el-form-item label="资产码">
          <el-input v-model="protocolForm.assetsCode" disabled></el-input>
        </el-form-item>
        <el-form-item label="所属站点">
          <el-input v-model="protocolForm.siteName" disabled></el-input>
        </el-form-item>
        <el-form-item label="设备类型">
          <el-input v-model="protocolForm.typeName" disabled></el-input>
        </el-form-item>
        <el-form-item label="当前协议类型">
          <el-input :value="currentDevType == 0 ? '恒电聚能协议' : '云快充协议'" disabled></el-input>
        </el-form-item>
        <el-form-item label="新协议类型" prop="dev_type" :rules="{ required: true, message: '请选择协议类型', trigger: 'change' }">
          <el-select v-model="protocolForm.dev_type" placeholder="请选择协议类型" style="width:100%">
            <el-option label="恒电聚能协议" :value="0"></el-option>
            <el-option label="云快充协议" :value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="protocolDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="protocolSubmitting" @click="confirmUpdateProtocolType">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import pageMixin from "@/mixins/pageMixin"
import { mapGetters } from "vuex"

import { getTripletPageListApi, updateTripletProtocolTypeApi } from "@/api/dev_archive"

export default {
  mixins: [pageMixin],
  data() {
    return {
      tableData: [],
      filter: {
        assetsCode: "",
        FactoryCode: "",
        siteName: ""
      },
      loading: false,
      protocolDialogVisible: false,
      protocolSubmitting: false,
      currentDevType: 0,
      protocolForm: {
        id: null,
        assetsCode: "",
        siteName: "",
        typeName: "",
        dev_type: 0
      }
    }
  },
  created() {
    this.getData()
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    getData() {
      this.loading = true
      getTripletPageListApi({
        page: this.pageParams.page,
        pagesize: this.pageParams.limit,
        assetsCode: this.filter.assetsCode || null,
        FactoryCode: this.filter.FactoryCode || null,
        siteName: this.filter.siteName || null
      }).then((res) => {
        console.log(res)
        this.tableData = res.data
        this.pageParams.total = res.total
      }).finally(() => {
        this.loading = false
      })
    },
    onUpdateProtocolType(rowData) {
      this.currentDevType = rowData.dev_type
      this.protocolForm = {
        id: rowData.ID,
        assetsCode: rowData.assetsCode,
        siteName: rowData.SiteName,
        typeName: rowData.TypeName,
        dev_type: rowData.dev_type
      }
      this.protocolDialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.protocolFormRef) {
          this.$refs.protocolFormRef.clearValidate()
        }
      })
    },
    confirmUpdateProtocolType() {
      this.$refs.protocolFormRef.validate((valid) => {
        if (!valid) {
          return
        }
        this.protocolSubmitting = true
        updateTripletProtocolTypeApi({
          id: this.protocolForm.id,
          dev_type: this.protocolForm.dev_type
        }).then((res) => {
          if (res.status === true || res.success === true || res.data === true) {
            this.$message.success("修改成功")
            this.protocolDialogVisible = false
            this.getData()
          } else {
            this.$message.error(res.msg || res.message || "修改失败")
          }
        }).catch((err) => {
          this.$message.error(err.message || "修改失败")
        }).finally(() => {
          this.protocolSubmitting = false
        })
      })
    }
  }

}
</script>

<style>

</style>